import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import Constants from '../../../definitions/constants';
import InterfaceTooling from '../../../tooling/interfaceTooling';

import GlassPopup from '../common/interface/glassPopup';
import ErrorFeedback from '../common/feedback/errorFeedback';
import Select from '../common/inputs/select';
import FieldInfo from '../common/inputs/fieldInfo';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import TextBox from '../common/inputs/textBox';

const ImportFormulaGrammarPopup = props => {
  const {
    handleShowPopup,
    handleButton,
    loadingButton,
    fullLoading,
    handleOnChangeFormData,
    statusButton,
    formContent,
    errors,
    popupState,
  } = props;
  return (
    <GlassPopup
      className="form_popup import_grammar_form_popup"
      title={(<FormattedMessage id="polynomialAdmin.importFormulaGrammar.title"/>)}
      buttonText={(<FormattedMessage id="polynomialAdmin.importFormulaGrammar.button"/>)}
      {...props}
    >
      <ErrorFeedback
        status={statusButton}
        fieldErrors={errors}
      />
      <textarea className="grammar_text_input" onChange={handleOnChangeFormData} value={formContent}></textarea>
      <p className="form_paragraph">
        <FormattedMessage id="polynomialAdmin.importFormulaGrammar.formulaWarning"/>
      </p> 
    </GlassPopup>
  );
};

export default ImportFormulaGrammarPopup;



// WEBPACK FOOTER //
// ./source/client/components/formulaEditor/importFormulaGrammarPopup.jsx